// React Imports
import * as React from 'react';
import {useEffect, useState, useMemo} from "react";
import {Controller, useFieldArray,useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Checkbox,
    FormControl, FormControlLabel,
    FormHelperText,
    Input,
    InputLabel, Radio,
    RadioGroup,
    Select,
    Stack,
    Typography
} from "@mui/material";

// App Imports

import MenuItem from "@mui/material/MenuItem";
import {getHelperItems, updateContractSectionContents} from "../ContractSection/ContractSectionClient";
import {changeContractSection} from "../ContractSection/contractSectionSlice";
import {changeContractDrilldownCS} from "../ContractDrilldown/ContractDrilldownCS/contractDrilldownSliceCS";
import {changeHelper} from "../ContractDrilldown/ContractDrilldownCS/Helpers/helperSlice";




// Main Function
export default function NotesDrawer({clearForm}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN REGISTER ****************************

    const {
        register,
        control,
        handleSubmit,
        setValue,
        reset
    } = useForm({
        defaultValues: {
            "12406": [{value: ""}],
            "12407": [{value: ""}]
        }
    });

    const {
        fields: lineItemFields,
        append: appendLineItem,
        remove: removeLineItem,
        replace: replaceLineItems
    } = useFieldArray({
        control,
        name: "12406"
    });

    const {
        fields: summaryItemFields,
        append: appendSummaryItem,
        remove: removeSummaryItem,
        replace: replaceSummaryItems
    } = useFieldArray({
        control,
        name: "12407"
    });


    // const lineItemOptions = [
    //     {id: 1, name: "Advertising Coop"},
    //     {id: 4, name: "Advertising Print"},
    //     {id: 7, name: "Distribution Fees"}
    // ];
    //
    // const summaryItemOptions = [
    //     {id: 101, name: "Gross Receipts"},
    //     {id: 102, name: "Allowed Expenses"},
    //     {id: 103, name: "Net Proceeds"}
    // ];

    // ****************** END REGISTER ****************************


    // ****************** BEGIN STORE ****************************

    const selectorContractSectionId = useSelector((state) => state.contractSectionSlc.value.id);

    const dispatchData = useDispatch() ;

    const [lineItemOptions, setLineItemOptions] = useState([]);
    const [summaryItemOptions, setSummaryItemOptions] = useState([]);

    const filteringMethodDropdown = ["","Has","Does Not Have"];
    const parentItemDropdown = ["","Gross Receipts","Allowed Expenses"];
    const [clearAll, setClearAll] = useState(false);
    // const [selectedFilteringMethod, setSelectedFilteringMethod] = useState('');
    const [selectedParentItem, setSelectedParentItem] = useState('');

    const selectorRawContents = useSelector((state) => state.contractSectionSlc.value.contents);
    const selectorContents = useMemo(() => {
        if (!selectorRawContents) {
            return {};
        }

        if (typeof selectorRawContents === "string") {
            try {
                return JSON.parse(selectorRawContents);
            } catch (error) {
                console.error(
                    "Unable to parse contract-section contents:",
                    error
                );

                return {};
            }
        }

        return selectorRawContents;
    }, [selectorRawContents]);
    // const selectorContents =
    //     typeof selectorRawContents === "string"
    //         ? JSON.parse(selectorRawContents)
    //         : selectorRawContents;

    // const selectorLabel = selectorContents?.["12029"];
    const selectorHelperMode =  useSelector((state) => state.contractDrilldownSlc.value.helperMode);
    const selectorLabel = useSelector((state) => state.helperSlc.value.label);
    const selectorShare = useSelector((state) => state.helperSlc.value.share);
    const selectorNetShare = useSelector((state) => state.helperSlc.value.netShare);
    const selectorRoyalty = useSelector((state) => state.helperSlc.value.royalty);
    const selectorMin = useSelector((state) => state.helperSlc.value.min);
    const selectorMax = useSelector((state) => state.helperSlc.value.max);
    const selectorFrom = useSelector((state) => state.helperSlc.value.fromAmount);
    const selectorTo = useSelector((state) => state.helperSlc.value.toAmount);
    const selectorDateFrom = useSelector((state) => state.helperSlc.value.dateFrom);
    const selectorDateTo = useSelector((state) => state.helperSlc.value.dateTo);
    const selectorAccountAction = useSelector((state) => state.helperSlc.value.accountAction);
    const selectorMarketAction = useSelector((state) => state.helperSlc.value.marketAction);
    const selectorDistributionChannelAction = useSelector((state) => state.helperSlc.value.distributionChannelAction);
    const selectorRegionAction = useSelector((state) => state.helperSlc.value.regionAction);
    const selectorCountryAction = useSelector((state) => state.helperSlc.value.countryAction);
    const selectorLanguageAction = useSelector((state) => state.helperSlc.value.languageAction);
    const selectorSummaryExpression = useSelector((state) => state.helperSlc.value.summaryExpression);
    const selectorSumSign = useSelector((state) => state.helperSlc.value.sumSign);

    useEffect(() => {
        register("12574");
        register("12406");
        register("12407");
        register("12029");
        register("12018");
        register("12056");
        register("12411");
        register("12412");
        register("12015");
        register("12071");
        register("12072");
        register("12074");
        register("12077");
        register("12080");
        register("12083");
        register("12086");
        register("12089");
        register("12110");
        register("11936");
        register("12100");
        register("12106");
        register("12107");
        register("11929");
        register("3664");
        register("12401");
        register("12413");
        register("12417");
        register("12476");
        register("12600");
        register("12601");
    }, [register]);

    useEffect(() => {
        const savedLineItems = Array.isArray(selectorContents?.["12406"])
            ? selectorContents["12406"]
            : [];

        const savedSummaryItems = Array.isArray(selectorContents?.["12407"])
            ? selectorContents["12407"]
            : [];

        reset({
            ...selectorContents,

            "12029": selectorLabel ?? "",
            "12018": selectorRoyalty ?? "",
            "12056": selectorMin ?? "",
            "12015": selectorMax ?? "",
            "12411": selectorFrom ?? "",
            "12412": selectorTo ?? "",
            "12071": selectorDateFrom ?? "",
            "12072": selectorDateTo ?? "",
            "12074": selectorAccountAction ?? "",
            "12077": selectorMarketAction ?? "",
            "12080": selectorDistributionChannelAction ?? "",
            "12083": selectorRegionAction ?? "",
            "12086": selectorCountryAction ?? "",
            "12089": selectorLanguageAction ?? "",
            "11929": selectorShare ?? "",
            "3664": selectorNetShare ?? "",
            "12401": selectorSummaryExpression ?? "",
            "12476": selectorSumSign ?? "4563",
            "12600": selectorMaxFee ?? "",
            "12601": selectorMaxBasis ?? "",


            "12406":
                savedLineItems.length > 0
                    ? savedLineItems.map(value => ({ value }))
                    : [{ value: "" }],

            "12407":
                savedSummaryItems.length > 0
                    ? savedSummaryItems.map(value => ({ value }))
                    : [{ value: "" }]
        });
    }, [
        selectorContractSectionId,
        selectorRawContents,
        reset
    ]);


    const selectorAccount = selectorContents?.["12023"] ?? [];
    const selectorContractId = useSelector((state) => state.contractSlc.value.id);

    // ****************** END STORE ****************************




    useEffect(() => {
        const fetchHelperItems = async () => {
            if (!selectorContractSectionId) return;

            console.log("fetching helper data");

            try {
                const helperItems =
                    await getHelperItems(selectorContractSectionId);

                console.log("helper items", helperItems);

                setLineItemOptions(
                    helperItems.filter(
                        data => data.itemDp ===  12108
                        // data => data.itemDp ===  12370
                    )
                );

                setSummaryItemOptions(
                    helperItems.filter(
                        data => data.itemDp === 12404
                        // data => data.itemDp === 12401
                    )
                );
            } catch (error) {
                console.error(
                    "Failed to fetch helper items",
                    error
                );
            }
        };

        fetchHelperItems();
    }, []);


    function onSubmit(data) {
        setSubmitting(true);

        const cleanedData = {
            ...data,

            "12406":
                data?.["12406"]
                    ?.map(item => item.value)
                    .filter(value =>
                        value !== "" &&
                        value !== null &&
                        value !== undefined
                    ) ?? [],

            "12407":
                data?.["12407"]
                    ?.map(item => item.value)
                    .filter(value =>
                        value !== "" &&
                        value !== null &&
                        value !== undefined
                    ) ?? []
        };

        console.log("Submitting form:", cleanedData);

        updateContractSectionContents(
            selectorContractSectionId,
            cleanedData
        )
            .then(res => {
                console.log("Updated contents:", data);
                console.log("Updated line item data for this section:", selectorContractSectionId);
                return updateLineItem(selectorContractSectionId);
            })
            .then(data => {
                console.log("Updated line item data:", data);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Data Submitted"}));

            })
            .catch(err => {
                console.error("Failed to update contents", err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Submit Failed"}));
            })
            .finally(() => {
                dispatchData(
                    changeContractSection({
                        csGridRefresh: true
                    }));

                setSubmitting(false);
            });
    }


    useEffect(() => {
        const savedLineItems = Array.isArray(selectorContents?.["12406"])
            ? selectorContents["12406"]
            : [];

        const savedSummaryItems = Array.isArray(selectorContents?.["12407"])
            ? selectorContents["12407"]
            : [];

        reset({
            ...selectorContents,

            "12406":
                savedLineItems.length > 0
                    ? savedLineItems.map(value => ({value}))
                    : [{value: ""}],

            "12407":
                savedSummaryItems.length > 0
                    ? savedSummaryItems.map(value => ({value}))
                    : [{value: ""}]
        });
    }, [
        selectorContractSectionId,
        selectorRawContents,
        reset
    ]);


    // ****************** BEGIN CLOSE ***************************
    function closeQfDrawer() {
        dispatchData(changeContractSection({csGridRefresh: true}));
        dispatchData(changeContractDrilldownCS({QfDrawerState: false }));
    };
// ******************** END CLOSE ********************************



    // const didMountRef = React.useRef(false);

    const handleClearAll = React.useCallback(() => {
        setClearAll(prev => !prev);
        setSelectedParentItem(null);
        console.log("Clear All button clicked");
        dispatchData(changeHelper({
            content: null,
            contentClean: null,
            label: null,
            royalty: null,
            min: null,
            max: null,
            fromAmount: null,
            toAmount: null,
            dateFrom: null,
            dateTo: null,
            accountAction: "Includes",
            marketAction: "Includes",
            distributionChannelAction: "Includes",
            regionAction: "Includes",
            countryAction: "Includes",
            languageAction: "Includes",
            sumSign: "4563"
        }));

        replaceLineItems([{value: ""}]);
        replaceSummaryItems([{value: ""}]);
        setValue("12574", "");
        setValue("12029", "");
        setValue("12018", "");
        setValue("12056", "");
        setValue("12015", "");
        setValue("12411", "");
        setValue("12412", "");
        setValue("12071", "");
        setValue("12072", "");
        setValue("11929", "");
        setValue("3664", "");
        setValue("12401", "");
        setValue("12600","");
        setValue("12601","");

        setValue("12023", []);
        setValue("12025", []);
        setValue("12027", []);
        setValue("12020", []);
        setValue("12019", []);
        setValue("12022", []);
        setValue("12110", []);
        setValue("11936", []);
        setValue("12100", []);
        setValue("12106", []);
        setValue("12107", []);

        setValue("12074", "Includes");
        setValue("12077", "Includes");
        setValue("12080", "Includes");
        setValue("12083", "Includes");
        setValue("12086", "Includes");
        setValue("12089", "Includes");

        setValue("12476", "4563");
        // setValue("12074", "");
        // setValue("12077", "");
        // setValue("12080", "");
        // setValue("12083", "");
        // setValue("12086", "");
        // setValue("12089", "");

        console.log("Clear All button clicked");
    }, [
        dispatchData,
        replaceLineItems,
        replaceSummaryItems, setValue]);

    const labelFieldConfigByHelperMode = {
        "Overall Share": {
            selectorDataPointId: 12110,
            fieldName: "12110",
        },
        "Participant Gross Share": {
            selectorDataPointId: 11936,
            fieldName: "11936",
        },
        "Participant Net Share": {
            selectorDataPointId: 11936,
            fieldName: "11936",
        },
        "Adjusted Gross Receipts": {
            selectorDataPointId: 12100,
            fieldName: "12100",
        },
        "Gross Receipts": {
            selectorDataPointId: 12106,
            fieldName: "12106",
        },
        "Allowed Expenses": {
            selectorDataPointId: 12107,
            fieldName: "12107",
        },
        "Account: Mapped Dist": {
            selectorDataPointId: 12574,
            fieldName: "12574",
        },
        "Account: Mapped Prod": {
            selectorDataPointId: 12574,
            fieldName: "12574",
        },
        "Account: Other": {
            selectorDataPointId: 12574,
            fieldName: "12574",
        },
        "Line Item": {
            selectorDataPointId: 12029,
            fieldName: "12029",
        },
        "Summary Item": {
            selectorDataPointId: 12405,
            fieldName: "12405",
        },
        "Distribution Fee": {
            selectorDataPointId: 12413,
            fieldName: "12413",
        },
        "Overhead Fee": {
            selectorDataPointId: 12417,
            fieldName: "12417",
        },
    };

    const labelFieldConfig =
        // labelFieldConfigByHelperMode[selectorHelperMode] ?? labelFieldConfigByHelperMode["L"];
        labelFieldConfigByHelperMode[selectorHelperMode] ?? labelFieldConfigByHelperMode["Line Item"];



    const didMountRef = React.useRef(false);

    useEffect(() => {
        console.log("clearForm changed in child:", clearForm);

        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }

        handleClearAll();
    }, [clearForm, handleClearAll]);

    // ****************** BEGIN RETURN ****************************

    return (
        <form
            id="lineItemForm"
            onSubmit={handleSubmit((data)=>        onSubmit(data))}

        >

            <Box
                sx={{ width: 1000 , height: 300, pl: 5}}
                role="presentation"
            >

                <br/>


                <Stack direction="row" spacing={4}     alignItems="center" >

                </Stack>










                {selectorHelperMode === "Summary Item" && (
                    <Box>
                        <br />
                        <br />
                        <Typography sx={{fontWeight: 700}}>
                            Sum of ...
                        </Typography>

                        <br />

                        <Stack
                            direction="row"
                            spacing={8}
                            alignItems="flex-start"
                        >
                            {/* Line Items — data point 12406 */}
                            <Box sx={{width: 350}}>
                                {/*<Typography sx={{fontWeight: 700, mb: 1}}>*/}
                                {/*    Line Items*/}
                                {/*</Typography>*/}

                                <Stack spacing={2}>
                                    {lineItemFields.map((field, index) => (
                                        <Stack
                                            key={field.itemNumber}
                                            direction="row"
                                            spacing={1}
                                            alignItems="center"
                                        >
                                            <Controller
                                                name={`12406.${index}.value`}
                                                control={control}
                                                render={({field: controllerField}) => (
                                                    <FormControl
                                                        variant="standard"
                                                        fullWidth
                                                    >
                                                        <InputLabel>
                                                            Line Item {index + 1}
                                                        </InputLabel>

                                                        <Select
                                                            {...controllerField}
                                                            label={`Line Item ${index + 1}`}
                                                        >
                                                            <MenuItem value="">
                                                                <em>None</em>
                                                            </MenuItem>

                                                            {lineItemOptions.map(option => (
                                                                <MenuItem
                                                                    key={option.itemNumber}
                                                                    value={option.itemNumber}
                                                                >
                                                                    {option.itemLabel} ({option.itemNumber})
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            />

                                            <Button
                                                type="button"
                                                onClick={() => removeLineItem(index)}
                                                disabled={lineItemFields.length === 1}
                                            >
                                                Remove
                                            </Button>
                                        </Stack>
                                    ))}
                                </Stack>

                                <Button
                                    type="button"
                                    sx={{mt: 2}}
                                    onClick={() => appendLineItem({value: ""})}
                                >
                                    Add Another Line Item
                                </Button>
                            </Box>

                            {/* Summary Items — data point 12407 */}
                            <Box sx={{width: 350}}>
                                {/*<Typography sx={{fontWeight: 700, mb: 1}}>*/}
                                {/*    Summary Items*/}
                                {/*</Typography>*/}

                                <Stack spacing={2}>
                                    {summaryItemFields.map((field, index) => (
                                        <Stack
                                            key={field.itemNumber}
                                            direction="row"
                                            spacing={1}
                                            alignItems="center"
                                        >
                                            <Controller
                                                name={`12407.${index}.value`}
                                                control={control}
                                                render={({field: controllerField}) => (
                                                    <FormControl
                                                        variant="standard"
                                                        fullWidth
                                                    >
                                                        <InputLabel>
                                                            Summary Item {index + 1}
                                                        </InputLabel>

                                                        <Select
                                                            {...controllerField}
                                                            label={`Summary Item ${index + 1}`}
                                                        >
                                                            <MenuItem value="">
                                                                <em>None</em>
                                                            </MenuItem>

                                                            {summaryItemOptions.map(option => (
                                                                <MenuItem
                                                                    key={option.itemNumber}
                                                                    value={option.itemNumber}
                                                                >
                                                                    {option.itemLabel} ({option.itemNumber})
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            />

                                            <Button
                                                type="button"
                                                onClick={() => removeSummaryItem(index)}
                                                disabled={summaryItemFields.length === 1}
                                            >
                                                Remove
                                            </Button>
                                        </Stack>
                                    ))}
                                </Stack>

                                <Button
                                    type="button"
                                    sx={{mt: 2}}
                                    onClick={() => appendSummaryItem({value: ""})}
                                >
                                    Add Another Summary Item
                                </Button>
                            </Box>
                        </Stack>
                    </Box>
                )}




                {/*</Stack>*/}
                <br/>
                <br/>
                <br/>
                {/*<Button*/}
                {/*    type= "submit"*/}
                {/*>Submit</Button>*/}
                {/*<Button onClick={() => closeQfDrawer()}>Cancel</Button>*/}
            </Box>
        </form>
    );

    // ****************** END RETURN ****************************

}
